@if (headerText !== '') {
  <div class="flex flex-row justify-center" [class.spacer]="!hasEmbeddedComponent">
    <div class="mb-5 flex w-full flex-row items-center justify-center">{{ headerText }}</div>
  </div>
}

@if (shouldAllowSearching) {
  <div class="mb-4 flex flex-row items-center justify-around">
    <wedate-input
      [dateHandler]="handler"
      [hasIncrementors]="shouldHaveIncrementors"
      [shouldDisable]="shouldDisableWeDate"
      (weDateChanged)="handleDateChange()"
    />
    <mat-form-field [hideRequiredMarker]="true">
      <mat-label>Add Cost Center</mat-label>
      <input
        type="number"
        min="1"
        placeholder="123456"
        matInput
        [formControl]="costCenterFormCtrl"
        (blur)="resetCostCenterValidationIfEmpty()"
      />
      @if (retrievedCostCenterInfo) {
        <mat-hint>
          <strong>{{ retrievedCostCenterInfo.Description }}</strong>
        </mat-hint>
      }
      @if (costCenterFormCtrl.hasError('required') || costCenterFormCtrl.hasError('pattern')) {
        <mat-error>
          <strong>Must be 6 numbers</strong>
        </mat-error>
      }
      @if (costCenterFormCtrl.hasError('costCenterDoesNotExist')) {
        <mat-error>
          <strong>Invalid cost center</strong>
        </mat-error>
      }
    </mat-form-field>
  </div>
}
<bar-select
  itemName="Contract"
  [items]="contracts"
  [isSearching]="isSearching"
  [class]="barsClass"
  (itemChosen)="select($event)"
/>
